import { useContext } from 'react';
import themeContext from '../context/theme/themeContext';

type Props = {
    isLoading: boolean;
    text?: string;
    children: any;
};

const Loading = ({ isLoading, text = 'Loading...', children }: Props) => {
    const { theme } = useContext(themeContext);

    return isLoading ? (
        <div className={`loading-container ${theme}`}>
            <div className='loading-animation'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='loading-text'>{text}</div>
        </div>
    ) : (
        children
    );
};

export default Loading;
